import React from 'react';
import { Mail, Phone, MessageCircle, Code2, GraduationCap, ExternalLink } from 'lucide-react';
import { Separator } from './ui/Separator';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full border-t border-border bg-card mt-auto" data-id="element-66">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8" data-id="element-67">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-68">
          {/* Brand */}
          <div data-id="element-69">
            <div className="flex items-center gap-2 mb-3" data-id="element-70">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center" data-id="element-71">
                <GraduationCap className="h-4 w-4 text-white" data-id="element-72" />
              </div>
              <div data-id="element-73">
                <h3 className="font-heading font-bold text-base leading-none" data-id="element-74">
                  {t('app.name')}
                </h3>
              </div>
            </div>
            <p className="text-sm text-muted-foreground" data-id="element-75">
              {t('app.description')}
            </p>
          </div>

          {/* Admin Contact */}
          <div data-id="element-76">
            <h4 className="font-heading font-semibold text-sm mb-3 uppercase tracking-wider text-muted-foreground" data-id="element-77">
              {t('footer.admin.contact')}
            </h4>
            <div className="space-y-2 text-sm" data-id="element-78">
              <p className="font-medium" data-id="element-79">BAYAVUGE THEOGEN</p>
              <div className="flex items-center gap-2 text-muted-foreground" data-id="element-80">
                <Mail className="h-3.5 w-3.5" data-id="element-81" />
                <span data-id="element-82">theobayavuge1@gmail.com</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground" data-id="element-83">
                <Phone className="h-3.5 w-3.5" data-id="element-84" />
                <span data-id="element-85">MTN: 0783138128</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground" data-id="element-86">
                <MessageCircle className="h-3.5 w-3.5" data-id="element-87" />
                <a href="https://wa.me/250783138128" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors" data-id="element-88">
                  {t('footer.whatsapp')}: 0783138128
                </a>
              </div>
            </div>
          </div>

          {/* Developer */}
          <div data-id="element-89">
            <h4 className="font-heading font-semibold text-sm mb-3 uppercase tracking-wider text-muted-foreground" data-id="element-90">
              {t('footer.developer')}
            </h4>
            <div className="space-y-3 text-sm" data-id="element-91">
              {/* Developer Badge */}
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-purple-500/30 bg-purple-500/5" data-id="element-92">
                <div className="h-7 w-7 rounded-md bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center" data-id="element-93">
                  <Code2 className="h-3.5 w-3.5 text-white" data-id="element-94" />
                </div>
                <div data-id="element-95">
                  <p className="font-semibold text-xs leading-none" data-id="element-96">
                    Bazatsinda Paulin
                  </p>
                  <p className="text-[10px] text-muted-foreground mt-0.5" data-id="element-97">
                    Full-Stack Developer
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground" data-id="element-98">
                <Mail className="h-3.5 w-3.5" data-id="element-99" />
                <span data-id="element-100">bazatsindapaulin@gmail.com</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground" data-id="element-101">
                <Phone className="h-3.5 w-3.5" data-id="element-102" />
                <span data-id="element-103">0792694883</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-6" data-id="element-104" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground" data-id="element-105">
          <p data-id="element-106">
            © {new Date().getFullYear()} {t('app.name')}. {t('footer.rights')}.
          </p>
          <p className="flex items-center gap-1.5" data-id="element-107">
            <Code2 className="h-3 w-3" data-id="element-108" />
            Built by Bazatsinda Paulin
            <ExternalLink className="h-2.5 w-2.5" data-id="element-109" />
          </p>
        </div>
      </div>
    </footer>;
}